import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  FaHome,
  FaPlayCircle,
  FaNewspaper,
  FaRegNewspaper,
  FaUser,
} from "react-icons/fa";

const activeClass =
  "flex flex-col items-center justify-center text-purple-600 gap-1";
const normalClass =
  "flex flex-col items-center justify-center text-gray-400 gap-1";

const MobileBottomNav = () => {
  const { t } = useTranslation();
  return (
    <nav
      className="
        fixed bottom-0 left-0 right-0 z-50
        bg-rich-black border-zinc-800 border-t shadow-md h-16
        flex justify-around items-center
        md:hidden
      "
    >
      {/* Home */}
      <NavLink
        to="/"
        className={({ isActive }) =>
          isActive ? activeClass : normalClass
        }
      >
        <FaHome className="text-[20px]" />
        <span className="text-[10px] leading-none font-medium">{t('sidebar.home', 'होम')}</span>
      </NavLink>

      {/* Video */}
      <NavLink
        to="/gallery/videos"
        className={({ isActive }) =>
          isActive ? activeClass : normalClass
        }
      >
        <FaPlayCircle className="text-[20px]" />
        <span className="text-[10px] leading-none font-medium">वीडियो</span>
      </NavLink>

      {/* Center News Tab (All Categories) */}
      <NavLink
        to="/news-categories"
        className={({ isActive }) =>
          isActive ? activeClass : normalClass
        }
      >
        <div className="w-10 h-10 rounded-full bg-purple-700 flex items-center justify-center shadow-lg -mt-6 border-2 border-white">
          <FaNewspaper className="text-white text-[20px]" />
        </div>
        <span className="text-[11px] leading-none font-bold text-purple-700 mt-0.5">न्यूज़</span>
      </NavLink>

      {/* National News */}
      <NavLink
        to="/category/national"
        className={({ isActive }) =>
          isActive ? activeClass : normalClass
        }
      >
        <FaRegNewspaper className="text-[20px]" />
        <span className="text-[10px] leading-none font-medium">{t('sidebar.national', 'राष्ट्रीय')}</span>
      </NavLink>

      {/* Contact */}
      <NavLink
        to="/contact"
        className={({ isActive }) =>
          isActive
            ? "flex flex-col items-center gap-1 text-purple-600"
            : "flex flex-col items-center gap-1 text-gray-400"
        }
      >
        <FaUser className="text-[20px]" />
        <span className="text-[10px] leading-none font-medium">संपर्क</span>
      </NavLink>
    </nav>
  );
};

export default MobileBottomNav;
